
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/user/payment",
      function () {
        return require("private-next-pages/user/payment/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/user/payment"])
      });
    }
  